export default __webpack_public_path__ + "static/media/logo_payme.dce633b9.png";